import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import Actions from "@/dictionary/tracking/actions";
import { trackIncentiveAction } from "@/utils/tracking/incentive-tracking";
import { Ref } from "vue";

export default class GoToForgotPassword {
	constructor(private store: IIncentiveV2Store, private readonly isForgotPassword: Ref<boolean>) {}

	public goToForgotPassword(): void {
		this.store.mutations.setResetPasswordEmailSent(false);
		this.store.mutations.setErrorMessage({ message: null, type: null });
		this.isForgotPassword.value = true;
		trackIncentiveAction(
			Actions.FORGOT_PASSWORD_CLICK,
			this.store.getters.incentiveType(),
			this.store.getters.location(),
			this.store.getters.uniqueIdentifier(),
		);
	}
}
